import { PortActionTypes } from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';

type PortPurposeEntry = {
	type?: Values<typeof PortActionTypes> | null;
	port?: {
		eu?: boolean;
	} | null;
};

export const getEuCompliancePurpose = (
	entry: PortPurposeEntry,
): Values<typeof PortActionTypes> | null => {
	if (entry.type == null) {
		return null;
	}

	if (entry.type === PortActionTypes.BALLAST_LEG) {
		return PortActionTypes.COMMENCEMENT;
	}

	return entry.type;
};

export const isEuCompliancePurpose = (
	entry: PortPurposeEntry,
	eligiblePortPurposes: ReadonlyArray<Values<typeof PortActionTypes>>,
) => {
	const purpose = getEuCompliancePurpose(entry);

	return purpose != null && eligiblePortPurposes.includes(purpose);
};

export const qualifiesForEuComplianceCosts = (
	entry: PortPurposeEntry,
	eligiblePortPurposes: ReadonlyArray<Values<typeof PortActionTypes>>,
) => (
	entry.port?.eu === true &&
	isEuCompliancePurpose(entry, eligiblePortPurposes)
);

export const getEuSeaPassageQualifyingPercent = ({
	fromEu,
	toEu,
}: {
	fromEu: boolean;
	toEu: boolean;
}) => {
	if (fromEu && toEu) {
		return 100;
	}

	if (fromEu || toEu) {
		return 50;
	}

	return 0;
};

